(function ($, Cobalt, undefined) {
    var hellBanTypeValue = 2;

    Cobalt.CPBan =
    {
        initialize: function () {
            $(".user-edit").on("change", "#field-ban-type", function () {
                Cobalt.CPBan.handleBanTypeChanged($(this));
            });
            Cobalt.CPBan.handleBanTypeChanged($("#field-ban-type"));
        },
        handleBanTypeChanged: function ($banType) {
            var $selectedItem = $banType.find("option:selected");
            if ($selectedItem.data("is-forum-ban-definition") === "True") {
                $("div.forum-selection").show();
            } else {
                $("div.forum-selection").hide();
            }
            
            // enable/disable permanent warning checkbox
            var $permanentWarning = $("#field-is-permanent-warning");
            var $expireValue = $("#field-expire-value");
            var $expireHiddenValue = $("#field-expire > .hidden-time-span");
            if ($selectedItem.data("ban-type") === hellBanTypeValue) {
                $expireValue.val(null);
                $expireHiddenValue.val(null);
                $expireValue.prop("disabled", true);
                $permanentWarning.attr("checked", "checked");
                $permanentWarning.prop("disabled", true);
            } else {
                $permanentWarning.prop("disabled", false);
                $expireValue.prop("disabled", false);
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPBan.js